"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isDarkColor = _interopRequireDefault(require("is-dark-color"));
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3, _theme$palette4, _theme$palette5, _theme$palette6;
  return {
    button: {
      minHeight: 44,
      padding: theme.spacing(1, 2.5)
    },
    label: {
      fontSize: "0.875rem"
    },
    counter: {
      backgroundColor: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main,
      borderColor: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.primary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main,
      cursor: "pointer",
      height: 18,
      marginLeft: theme.spacing(0.75),
      width: 18,
      "& span": {
        color: (0, _isDarkColor.default)((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.primary) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.main) ? theme.palette.common.white : theme.palette.text.primary,
        fontSize: "0.625rem",
        padding: 0
      }
    },
    counterSelected: {
      borderColor: (0, _isDarkColor.default)((_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 || (_theme$palette4 = _theme$palette4.primary) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.main) ? theme.palette.common.white : theme.palette.text.primary,
      "& span": {
        color: (0, _isDarkColor.default)((_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 || (_theme$palette5 = _theme$palette5.primary) === null || _theme$palette5 === void 0 ? void 0 : _theme$palette5.main) ? theme.palette.common.white : theme.palette.text.primary
      }
    },
    icon: {
      marginLeft: 2
    },
    menu: {
      padding: theme.spacing(2),
      width: 300,
      "& .mco-filter-item": {
        marginBottom: 0,
        "&__label": {
          display: "none"
        },
        "&__search": {
          "& svg": {
            marginRight: theme.spacing(1)
          }
        },
        "&__option-wrapper": {
          maxHeight: 215,
          paddingBottom: 0
        },
        "&__option": {
          borderBottom: "1px solid #CCCCCC",
          marginBottom: 0,
          paddingBottom: theme.spacing(0.5),
          paddingTop: theme.spacing(0.5),
          "&:last-child": {
            borderBottom: 0
          }
        },
        "&__option-form-control-label": {
          "& span.count": {
            color: (_theme$palette6 = theme.palette) === null || _theme$palette6 === void 0 || (_theme$palette6 = _theme$palette6.text) === null || _theme$palette6 === void 0 ? void 0 : _theme$palette6.disabled,
            fontSize: "0.875rem"
          }
        }
      }
    }
  };
});
var _default = exports.default = styles;